import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'

export const getCrmIntegrationChatAccessDeniedAlert = (
  provider: CrmChatProviderKey,
): string => {
  if (provider === 'vkontakte') {
    return 'У вас нет доступа к чату этого сообщества. Обратитесь к администратору платформы.'
  }

  if (provider === 'wazzup') {
    return 'У вас нет доступа к чату этого аккаунта Wazzup. Обратитесь к администратору платформы.'
  }

  return 'У вас нет доступа к чату этого бота. Обратитесь к администратору платформы.'
}
